import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'app-org-settings-event-request-config',
  templateUrl: './org-settings-event-request-config.component.html',
  styleUrls: ['./org-settings-event-request-config.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OrgSettingsEventRequestConfigComponent {}
